<script>
import Constants from '../constants';
import simpleLoading from '@/components/simpleLoading';

export default {
  name: 'vueTwitter',
  components: {
    // Timeline,
    simpleLoading
  },
  data() {
    return {
      ready: false,
      tweetLimit: 10,
      followTwitterUrl: '',
      targetUrl: '',
      locale: '',
      twitterScriptDom: null,
    };
  },
  mounted() {
    this.targetUrl = `https://twitter.com/${Constants.SNS.TWITTER_ID}?ref_src=twsrc%5Etfw`;
    this.followTwitterUrl = `https://twitter.com/intent/follow?&region=follow_link&screen_name=${Constants.SNS.TWITTER_ID}`;
    this.locale = this.$i18n.locale || 'ja';

    setTimeout(()=> {
      this.ready = true;
      setTimeout(() => {
        this.twitterScriptDom = document.createElement('script');
        this.twitterScriptDom.setAttribute('src', 'https://platform.twitter.com/widgets.js');
        this.twitterScriptDom.setAttribute('async', 'true');
        this.twitterScriptDom.setAttribute('charset', 'utf-8');
        this.$el.appendChild(this.twitterScriptDom);
      }, 100);
    }, 1001);
  },
  beforeDestroy() {
    if (this.twitterScriptDom) {
      this.$el.removeChild(this.twitterScriptDom);
    }
  },
};
</script>

<template>
  <div class="twitter-container" v-if="ready">
    <div class="loading">
      <div class="warn-text">{{$t('message.information.snsWarning') }}</div>
      <simple-loading/>
    </div>
    <div class="timeline-container">
      <a
        class="twitter-timeline"
        data-dnt="true"
        :data-lang="locale"
        :href="targetUrl"
        target="_blank"
        data-theme="light"
        data-chrome="noborders nofooter noheader"
      >
        {{$t('message.snsName.openTwitter')}}
      </a>
    </div>
    <a
      class="follow-me-btn"
      :title="$t('message.snsName.twitter')"
      target="_blank"
      :href="followTwitterUrl"
    ></a>
  </div>
</template>

<style lang="scss" scoped>
  @import "../css/variables";
  .twitter-container {
    position: relative;
    width: 100%;
    height: 100%;
    .loading {
      @include absolute100;
      .warn-text {
        position: absolute;
        bottom: 25%;
        font-size: 0.8em;
      }
    }
    .timeline-container {
      position: relative;
      width: 100%;
      height: 100%;
      overflow-y: scroll;
      .twitter-timeline {
        font-size: 0.8em;
      }
    }
    .follow-me-btn {
      z-index: $zIndexFollowMeBtn;
      position: absolute;
      bottom: -35px;
      right: 0px;
      display: block;
      width: 110px;
      height: 70px;
      @include bgCenter;
      background-image: url(../assets/img/sns/followTwitter.svg);
      cursor: pointer;
      transition: 0.1s ease-out;
      &:hover {
        transform: translateY(-10px);
      }
    }
  }
</style>
